import * as React from 'react';

import { useModalWindowWithParams } from '../../../utils/useModalWindowWithParams';
import { EDealStepModalTypes } from '../content';
import { trackDealStepModalShow } from '../tracking';

export type TDealStepModalNavigationProps = ReturnType<typeof useDealStepsModalNavigation>[2];

export function useDealStepsModalNavigation() {
  const modalTopRef = React.useRef<HTMLDivElement>(null);
  const [modalProps, openDealStepModal] = useModalWindowWithParams<{
    modalType: EDealStepModalTypes;
  }>();

  const goForward = () => {
    // Сейчас в использовании переходы будут доступны только при открытой моделке
    /* istanbul ignore next */
    if (!modalProps.open) {
      return;
    }
    const nextModal = {
      [EDealStepModalTypes.Application]: EDealStepModalTypes.DocumentSigning,
      [EDealStepModalTypes.DocumentSigning]: EDealStepModalTypes.RosreestrRegistration,
      [EDealStepModalTypes.RosreestrRegistration]: EDealStepModalTypes.RosreestrRegistration,
    }[modalProps.modalType];

    trackDealStepModalShow({ modalType: nextModal, source: 'navigation' });
    openDealStepModal({ modalType: nextModal });
    modalTopRef.current?.scrollIntoView();
  };

  const goBackward = () => {
    /* istanbul ignore next */
    if (!modalProps.open) {
      return;
    }
    const nextModal = {
      [EDealStepModalTypes.Application]: EDealStepModalTypes.Application,
      [EDealStepModalTypes.DocumentSigning]: EDealStepModalTypes.Application,
      [EDealStepModalTypes.RosreestrRegistration]: EDealStepModalTypes.DocumentSigning,
    }[modalProps.modalType];

    trackDealStepModalShow({ modalType: nextModal, source: 'navigation' });
    openDealStepModal({ modalType: nextModal });
    modalTopRef.current?.scrollIntoView();
  };

  const openDealStepModalWithTracking = ({ modalType }: { modalType: EDealStepModalTypes }) => {
    trackDealStepModalShow({ modalType, source: 'learn_more' });
    openDealStepModal({ modalType });
  };

  return [
    modalProps,
    openDealStepModalWithTracking,
    {
      goForward,
      goBackward,
      isFirstStep: modalProps.open && modalProps.modalType === EDealStepModalTypes.Application,
      isLastStep: modalProps.open && modalProps.modalType === EDealStepModalTypes.RosreestrRegistration,
    },
    modalTopRef,
  ] as const;
}
